import React from "react";
import abotimg from "./../assets/png/about.png";
import { DexoIcon } from "../helper/Icon";
function About() {
  return (
    <>
      <div className="about-bg bg-[#F2F4F9]">
        <div
          id="About"
          className="max-w-[1624px] mx-auto px-4 sm:px-6 lg:px-8 my-12 xl:my-20"
        >
          <div className="flex flex-col-reverse md:flex-row items-center gap-10  md:gap-5 justify-between ">
            <div
              className="max-w-[702px] "
              data-aos="fade-down"
              data-aos-duration="1500"
            >
              <img src={abotimg} alt="img" className="w-full" />
            </div>
            <div
              className="max-w-[726px]"
              data-aos="fade-left"
              data-aos-duration="3000"
            >
              <h2 className="text-black text-3xl sm:text-5xl  xl:text-[70px] 2xl:text-[100px] text-aircruiser xl:tracking-[-2px] text-shadow-2">
                ABOUT $JOSH
              </h2>
              <p className="text-black text-base sm:text-lg xl:text-xl 2xl:text-[24px] leading-[180%] lg:tracking-[0.48px] py-4 md:py-6 xl:py-8 2xl:py-10">
                Josh is the strongest man on Solana right now. Josh will burn
                the supply every single day based on the high score of the Josh
                game, growing the value every single day. Get in now.
              </p>{" "}
              <div className="flex  gap-3 sm:gap-4 xl:gap-6 flex-nowrap">
                <a
                  href="https://dexscreener.com/solana/7suklvbqlkam7iyot6omjwqgtehwuy6wp58b5ofphg88"
                  className="bg-[#0279E1] py-2 sm:py-2.5 xl:py-4 px-3 sm:px-6 md:px-5 xl:px-10  border border-black rounded-xl 
               shadow-[0px_6px_0px_0px_#000] text-white text-sm sm:text-lg md:text-xl 2xl:text-2xl  text-aircruiser   transition-all duration-300 ease-in-out hover:shadow-[0px_6px_20px_0px_#000]
              "
                >
                  Buy $JOSH
                </a>{" "}
                <a
                  href="https://josh-hero-03.netlify.app/
"
                  className="bg-white py-2 sm:py-2.5 xl:py-5 px-3 sm:px-6 md:px-5 xl:px-10  border border-black rounded-xl 
               shadow-[0px_6px_0px_0px_#000] text-black text-sm sm:text-lg md:text-xl 2xl:text-2xl  text-aircruiser   transition-all duration-300 ease-in-out hover:shadow-[0px_6px_20px_0px_#000] uppercase
              "
                >
                  Play Now
                </a>
                <a
                  href="https://www.dextools.io/app/en/solana/pair-explorer/7sukLVbqLkAm7iYot6oMjWQgtEHwuy6WP58B5ofpHG88?t=1721955553869"
                  className="bg-white py-2 sm:py-2.5 xl:py-5 px-3 sm:px-6 md:px-5 xl:px-10  border border-black rounded-xl 
               shadow-[0px_6px_0px_0px_#000] text-black text-sm sm:text-lg md:text-xl 2xl:text-2xl  text-aircruiser   transition-all duration-300 ease-in-out hover:shadow-[0px_6px_20px_0px_#000] uppercase flex items-center
              "
                >
                  {" "}
                  <DexoIcon />
                  <span className="ml-1 xl:ml-2"> dextools</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
